import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';
import { ReactComponent as TribeLogo } from '../../assets/TribeLogo.svg';

// -------------------------------
// Styles (match HostTopNav / Settings)
// -------------------------------
const headerContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  position: 'sticky',
  top: 0,
  background: '#fff',
  zIndex: 100,
};

const headerLogoRowStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 0,
  marginBottom: 8,
};

const logoSvgStyle = {
  width: 72,
  height: 'auto',
};

const headerNavRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  height: 44,
  padding: '0 0rem',
};

const backButtonStyle = {
  position: 'absolute',
  left: 0,
  background: '#000',
  color: '#fff',
  borderRadius: 9999,
  width: 40,
  height: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  border: 'none',
};

const pageTitleStyle = {
  fontSize: '0.95rem',
  fontWeight: 900,
  lineHeight: 1,
  textTransform: 'uppercase',
  letterSpacing: 0.2,
};

const statusWrapStyle = {
  position: 'absolute',
  right: 0,                 // ✅ mirror back button
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  height: 28,               // ✅ match back button height
  padding: '0 10px',        // light breathing room
  borderRadius: 9999,
  fontSize: 12,
  fontWeight: 700,
  color: '#111',
  background: '#fff',       // keep clean; no container feel
};

const statusDotStyle = {
  width: 8,
  height: 8,
  borderRadius: '50%',
};

// -------------------------------
// MAIN NAV COMPONENT
// -------------------------------
export default function HostPayoutNavbar({
  title = 'Payouts',
  backTo = '/host',
  payoutStatus, // optional
}) {
  const navigate = useNavigate();

  let statusLabel = '';
  let dotColor = '#9CA3AF'; // gray

  if (payoutStatus) {
    const { stripeConnected, stripeBankConnected, stripePayoutsEnabled } = payoutStatus;

    if (!stripeConnected) {
      statusLabel = 'Not connected';
      dotColor = '#DC2626'; // red
    } else if (!stripeBankConnected) {
      statusLabel = 'Inactive';
      dotColor = '#F59E0B'; // amber
    } else if (stripePayoutsEnabled) {
      statusLabel = 'Connected';
      dotColor = '#16A34A'; // green
    }
  }

  return (
    <header style={headerContainerStyle}>
      {/* Logo */}
      <div style={headerLogoRowStyle}>
        <TribeLogo style={logoSvgStyle} />
      </div>

      {/* Nav row */}
      <div style={headerNavRowStyle}>
        <button
          onClick={() => navigate(backTo)}
          style={backButtonStyle}
          aria-label="Back"
        >
          <LuArrowLeft size={16} color="#fff" />
        </button>

        {/* ✅ Title stays perfectly centered */}
        <div style={pageTitleStyle}>{title}</div>

        {/* ✅ Status sits on the right, never affecting title centering */}
        {statusLabel && (
          <div style={statusWrapStyle}>
            <span style={{ ...statusDotStyle, background: dotColor }} />
            <span>{statusLabel}</span>
          </div>
        )}
      </div>
    </header>
  );
}
